import './abritin2/style';
import FormStructure from './abritin2/form_structure';

export default FormStructure;